import dayOutDim from '@assets/svg/intention-day-out-dim.svg';
import dayOut from '@assets/svg/intention-day-out.svg';
import drinkDim from '@assets/svg/intention-lets-get-a-drink-dim.svg';
import drink from '@assets/svg/intention-lets-get-a-drink.svg';
import onlineDim from '@assets/svg/intention-online-texting-dim.svg';
import online from '@assets/svg/intention-online-texting.svg';
import softNightDim from '@assets/svg/intention-soft-night-in-dim.svg';
import softNight from '@assets/svg/intention-soft-night-in.svg';
import physicalDim from '@assets/svg/intention-something-physical-dim.svg';
import physical from '@assets/svg/intention-something-physical.svg';
import takeOutDim from '@assets/svg/intention-take-me-out-dim.svg';
import takeOut from '@assets/svg/intention-take-me-out.svg';
import { INTENTION_IDS, MAX_INTENTIONS, type IntentionId } from './intentionIds';

export { INTENTION_IDS, MAX_INTENTIONS, type IntentionId };

/**
 * Shared intentions catalog (v90 INTENT_DATA keys + copy keys + SVG icons).
 * Labels/descs live under `onboarding.steps.setIntentions`.
 */
export const INTENTIONS = [
  {
    id: 'physical',
    labelKey: 'steps.setIntentions.options.physical.label',
    descKey: 'steps.setIntentions.options.physical.desc',
    icon: physical,
    iconDim: physicalDim,
  },
  {
    id: 'softnight',
    labelKey: 'steps.setIntentions.options.softnight.label',
    descKey: 'steps.setIntentions.options.softnight.desc',
    icon: softNight,
    iconDim: softNightDim,
  },
  {
    id: 'drink',
    labelKey: 'steps.setIntentions.options.drink.label',
    descKey: 'steps.setIntentions.options.drink.desc',
    icon: drink,
    iconDim: drinkDim,
  },
  {
    id: 'takeout',
    labelKey: 'steps.setIntentions.options.takeout.label',
    descKey: 'steps.setIntentions.options.takeout.desc',
    icon: takeOut,
    iconDim: takeOutDim,
  },
  {
    id: 'dayout',
    labelKey: 'steps.setIntentions.options.dayout.label',
    descKey: 'steps.setIntentions.options.dayout.desc',
    icon: dayOut,
    iconDim: dayOutDim,
  },
  {
    id: 'online',
    labelKey: 'steps.setIntentions.options.online.label',
    descKey: 'steps.setIntentions.options.online.desc',
    icon: online,
    iconDim: onlineDim,
  },
] as const satisfies readonly {
  id: IntentionId;
  labelKey: string;
  descKey: string;
  icon: string;
  iconDim: string;
}[];

export type IntentionOption = (typeof INTENTIONS)[number];
